import { Component, OnInit} from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoService } from '../../../service/seo.service';
import { NavigationEnd, Router } from '@angular/router';
import { UrlcanonicaService } from '../../../service/urlcanonica.service';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { LicitacionService } from '../../../service/licitacion.service';

@Component({
  selector: 'app-listado-proveedor',
  templateUrl: './listado-proveedor.component.html',
  styleUrls: ['./listado-proveedor.component.css'],
})

export class ListadoProveedorComponent implements OnInit {
	private subscription: Subscription = new Subscription();
	RouteText : any;
	tituloseo: any;
	urlcanonicaseo: any;
	imagenseo: any;
	keywordsseo: any;
	descripcionseo: any;
	toggle:boolean = true;
	postulaciones!: any[];
	postulaciondel: any;
	////////
	confirma = false;
	success= false;
	fail = false;
	///////

	constructor( 
		private meta: Meta,
		private title: Title,
		private _seoService: SeoService,
		private router: Router,
		private _licitacionservice: LicitacionService,
		private _urlcanonicaservice: UrlcanonicaService
		) { 
			
			if((sessionStorage.getItem('token') == null || sessionStorage.getItem('token') == 'null')||(sessionStorage.getItem('rfc') == null || sessionStorage.getItem('rfc') == 'null')){
				this.router.navigate(['/licitaciones/login']);
			}
			this.router.events.pipe(filter((event: any) =>  event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
				this.RouteText = event;
				this.getSEO(event.url)
			});
		}
	
		getSEO(page: string) {
			this._seoService.getSEO(page).subscribe((resp: any) => {
				this.tituloseo = resp.titulo;
				this.descripcionseo = resp.descripcion;
				this.urlcanonicaseo = resp.urlcanonica;
				this.imagenseo = resp.image;
			
				this._urlcanonicaservice.createCanonicalLink();
				this.title.setTitle(this.tituloseo)
				this.meta.updateTag({name: 'description',content: this.descripcionseo})
				this.meta.updateTag({property: 'twitter:card',content: 'summary'})
				this.meta.updateTag({property: 'twitter:site',content: '@fundacionbest'})
				this.meta.updateTag({property: 'twitter:title',content: 'Fundación BEST'})
				this.meta.updateTag({property: 'twitter:description',content: this.descripcionseo})
				this.meta.updateTag({property: 'twitter:image',content: this.imagenseo})
				this.meta.updateTag({property: 'og:url',content: 'https://fundacionbest.org.mx/licitaciones/login'})
				this.meta.updateTag({property: 'og:title',content: this.tituloseo})
				this.meta.updateTag({property: 'og:image',content: this.imagenseo})
				this.meta.updateTag({property: 'og:description',content: this.descripcionseo})
			});
		}

	ngOnInit(): void {
		this.getPostulaciones();
	}

	getPostulaciones() {
		this.subscription.add(
			this._licitacionservice.getPostulacionbyid(sessionStorage.getItem('rfc'), sessionStorage.getItem('token')).subscribe((resp: any) => {
				this.postulaciones = resp.postulaciones;
				console.log(this.postulaciones)
			})
		);
	}

	//////////
	change(oferta: any){
		this.postulaciondel = oferta;
		this.confirma = true;
	}
	cancel() {
		this.confirma = false;
	}
	closeok() {
		this.success= false;
		this.fail = false;
		this.getPostulaciones();
	}

	goChange() {
		this.confirma = true;  
		this.subscription.add(
			
			this._licitacionservice.PostDelpostulacionbyid(this.postulaciondel.id, sessionStorage.getItem('token')).subscribe((resp: any) => {
				console.log(resp)
				if (resp.ok == false) {
					this.fail = true;
					this.confirma = false;
				} else if (resp.ok == true) {
					this.success = true;
					this.confirma = false;
				}
			})
		);
	}
  ////////////

}